module.exports = __webpack_public_path__ + "assets/img/profile-about-active.61d1f9d3.svg";